import { useState, useEffect } from 'react';

import { useGlobalAdminCheck } from '../../../../../hooks/useGlobalAdminCheck';
import { Breadcrumb } from '../../../../components/breadcrumb';
import { PageTitle } from '../../../../components/page-title';
import { AuditTrailTable } from '../../../components/audit-trail-table';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';

export function AuditTrail() {
  useGlobalAdminCheck();
  return (
    <>
      <Breadcrumb items={[{ href: '/audit-trail', label: 'Audit Trail', active: true }]} />
      <PageContainer>
        <PageHeader>
          <PageTitle text="Audit Trail" />
        </PageHeader>
      </PageContainer>
      <AuditTrailTable grammar="a" />
    </>
  );
}
